<script>
	import Star from './Star.svelte';

	let { fullName, children } = $props();
</script>

<div class="my-12 grid w-full max-w-3xl justify-items-start gap-y-2">
	<div class="grid grid-cols-[max-content_1fr] items-center gap-4">
		<p class="mb-0 text-xl font-bold">{fullName}</p>
		<div class="flex gap-x-1">
			<Star />
			<Star />
			<Star />
			<Star />
			<Star />
		</div>
	</div>
	<p class="text-start italic">{@render children?.()}</p>
</div>
